import * as youtubeEmailNotifications from './youtubeEmailNotifications'
import { isAccountDataGathered, youtubeSetAccountData } from './youtubeGather'
import * as youtubeQuickPurchase from './youtubePurchase'
import * as youtubePushNotifications from './youtubePushNotifications'
import * as youtubeSubscriptionPrivacy from './youtubeSubscriptionPrivacy'
import { YoutubeRecommendationKey } from '../../utils/enums'
import {
  RecommendationAutomationRegistryApi,
  RecommendationAutomationRegistry,
} from '../automationMachineInterfaces'
import * as manualRecommendation from '../manualRecommendation'

const REGISTRY: RecommendationAutomationRegistry = {
  [YoutubeRecommendationKey.YOUTUBE_PUSH_NOTIFICATIONS]:
    youtubePushNotifications,
  [YoutubeRecommendationKey.YOUTUBE_EMAIL_NOTIFICATIONS]:
    youtubeEmailNotifications,
  [YoutubeRecommendationKey.YOUTUBE_CONNECTED_APPS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        YoutubeRecommendationKey.YOUTUBE_CONNECTED_APPS,
      ),
    ],
  },
  [YoutubeRecommendationKey.YOUTUBE_SUBSCRIPTION_PRIVACY]:
    youtubeSubscriptionPrivacy,
  [YoutubeRecommendationKey.YOUTUBE_PURCHASE]: youtubeQuickPurchase,
}

export const youtubeRegistry: RecommendationAutomationRegistryApi = {
  getAccountUsernameGatherStageDefs: () => youtubeSetAccountData,
  getAdditionalFullGatherStageDefs: () => [],
  getRecommendationAutomationRegistry: () => REGISTRY,
  isAccountDataGathered: (accountData) => isAccountDataGathered(accountData),
}
